<template>
    <div class="contact">
        <headers :title="$t('联系我们')" img="contact"></headers>
        <div class="title">
            {{$t('联系方式')}}
        </div>
        <div class="line"></div>
        <div class="map" id="container"></div>
        <div class="text">
            <p class="main">{{$t('仙桃市誉诚无纺布制品有限公司')}}</p>
            <p class="address">{{$t('地址：仙桃市彭场镇新民路51-11')}}</p>
            <p class="call">{{$t('电话：0728-2616588')}}</p>
            <p class="mail">{{$t('邮箱：zhushuo@xiantaoyucheng.com')}}</p>
        </div>
        <div class="mail_box">
            <input type="text" :placeholder="$t('name')" class="inputText" v-model="name">
            <input type="text" :placeholder="$t('number')" class="inputText" v-model="number">
            <input type="text" :placeholder="$t('email')" class="inputText" v-model="email">
            <textarea :placeholder="$t('infoText')" cols="30" rows="10" v-model="email_text"></textarea>
            <!-- <input tyarr :placeholder="$t('infoText')" class="inputText" id=""> -->
            <div class="btn" @click="sendMessage()">{{$t('send')}}</div>
        </div>
        <foot></foot>     
    </div>
</template>
<script>
import headers from "@/components/headers.vue";
import foot from "@/components/foot.vue";
import MapLoader from '@/datas/AMap.js'
export default {
    components:{
      headers,foot
    },
    mounted(){
        this.render()
        if(this.$route.query.type=="Email"||this.$route.query.Type=="Email"){
            setTimeout(()=>{
                document.getElementsByClassName("mail_box")[0].scrollIntoView(true)        
            },500)
        }
    },
    data() {
        return {
            name:"",
            number:"",
            email:"",
            email_text:"",            
        }
    },
    watch:{
        '$i18n.locale'(){
            this.render()
        },
    },
    methods:{
        render(){
            let that = this
            MapLoader().then(AMap => {
            that.map = new AMap.Map('container', {
                center: [113.524473,30.256413],
                zoom: 11,
                lang:'zh_en'
            })
            var marker = new AMap.Marker({
                position: new AMap.LngLat(113.524473,30.256413),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                title: '誉诚防护'
            });
            let tem = `<div class="pp">
                <div class="pp_text">
                    <p class="pp_text_title">${this.$t('仙桃市誉诚无纺布制品有限公司')}</p>
                    <p class="pp_text_text">${this.$t('地址：仙桃市彭场镇新民路51-11')}</p>
                </div>
            </div>`
            var marker1 = new AMap.Marker({
                content: tem,  // 自定义点标记覆盖物内容
                position:  [113.524473,30.256413], // 基点位置
                offset: new AMap.Pixel(-120, -110) // 相对于基点的偏移位置
            });
            that.map.add(marker);
            that.map.add(marker1);
            }, e => {
                console.log('地图加载失败' ,e)
            })
        },
        sendMessage(){
            this.$axios({
                method:'post',
                url:this.ip + '/sendEmail',
                data:this.qs.stringify({
                    name:this.name,
                    number:this.number,
                    email:this.email,
                    email_text:this.email_text
                }),
                headers:{'Content-Type':'application/x-www-form-urlencoded'}
            }).then((response) =>{          //这里使用了ES6的语法
                alert('发送成功')
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
                alert(error)
            })
        }
    }
}
</script>
<style lang="less">
.contact{
    .title{
        width: 55%;
        margin: 30px auto;
        color: #444444;
        font-size: 1.4rem;
        font-weight: bold;
    }
    .mail_box{
        background-color: #f6f6f6;
        width: 60vw;
        min-height: 100px;
        margin: 0 auto;
        padding-top: 10px;
        padding-bottom: 10px;
        input,textarea{  
            background:none;  
            outline:none;  
            border:none;
            display: block;
            padding-left: 20px;
            margin: 0 auto;
            color: #999;
            margin-bottom: 20px;
            width: 90%;
            background-color: #fff;            
        }
        .btn{
            background-color: #017CA8;
            color: #fff;
            width: fit-content;
            margin-left: 5%;
            padding: 5px 30px;
            cursor: pointer;
            font-size: 0.8rem;
            letter-spacing: 3px;
            // font-weight: bold;
            font-family: 'YHBD';
        }
        .inputText{
            width: 90%;
            height: 2rem;
            background-color: #fff;
        }
    }
    .line{
        width: 55%;
        margin: 0 auto;
        border-bottom: 1px solid #BFBFBF;
    }
    .map{
        width: 55%;
        height: 350px;
        margin: 2rem auto;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    }
    .text{
        width: 55%;
        margin: 2.5rem auto;
        font-size: 0.7rem;
        .main{
            color: #017CA8;
            font-weight: bold;
            font-size: 1rem;
        }

        margin-bottom: 6rem;
    }
    .pp{
        width: 300px;
        position: relative;
        background-color:rgba(0, 0, 0, 0.7);
        border-radius: 5px;
        padding: 4px 0;
        .pp_text{
            text-align: center;
            color: #fff;
            width: 100%;          

            .pp_text_title{
                font-size: 0.7rem;
                width: 100%;
                font-weight: bold;
                line-height: 0.6rem;
            }
            .pp_text_text{
                font-size: 0.5rem;
                width: 100%;
                line-height: 0.6rem;
                
            }
        }
    }
}
</style>
<i18n>
{
  "en": {
       "联系我们":"CONTACT US",
       "联系方式":"Contact Details",
       "仙桃市誉诚无纺布制品有限公司":"Yucheng Nonwoven Products Co., Ltd.",
       "地址：仙桃市彭场镇新民路51-11":"Address: 51-11 Xinmin Road, Pengchang Town, Xiantao City",
       "电话：0728-2616588":"Phone: 0728-2616588",
       "邮箱：zhushuo@xiantaoyucheng.com":"Email: zhushuo@xiantaoyucheng.com" 
        ,"name":"*What's your name?",
        "number":"*Best contact number",
        "email":"*Your best contact email",
        "infoText":"*What do you wish to enquire about?",
        "send":"Send"
  },
  "zh": {
       "联系我们":"联系我们",
       "联系方式":"联系方式",
       "仙桃市誉诚无纺布制品有限公司":"仙桃市誉诚无纺布制品有限公司",
       "地址：仙桃市彭场镇新民路51-11":"地址：仙桃市彭场镇新民路51-11",
       "电话：0728-2616588":"电话：0728-2616588",
       "邮箱：zhushuo@xiantaoyucheng.com":"邮箱：zhushuo@xiantaoyucheng.com"   
        ,"name":"*您的名字是？",
        "number":"*您的联系电话是？",
        "email":"*您的Email是？",
        "infoText":"*您想对我们说什么？",
        "send":"发送"
    }
}
</i18n>

